/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentDetailsSourceOfMoneySplitViewModel
 */
export interface InvestmentDetailsSourceOfMoneySplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsSourceOfMoneySplitViewModel
     */
    annuitySourceAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsSourceOfMoneySplitViewModel
     */
    alternativeSourceAmount?: number;
}

/**
 * Check if a given object implements the InvestmentDetailsSourceOfMoneySplitViewModel interface.
 */
export function instanceOfInvestmentDetailsSourceOfMoneySplitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsSourceOfMoneySplitViewModelFromJSON(json: any): InvestmentDetailsSourceOfMoneySplitViewModel {
    return InvestmentDetailsSourceOfMoneySplitViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsSourceOfMoneySplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsSourceOfMoneySplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'annuitySourceAmount': !exists(json, 'AnnuitySourceAmount') ? undefined : json['AnnuitySourceAmount'],
        'alternativeSourceAmount': !exists(json, 'AlternativeSourceAmount') ? undefined : json['AlternativeSourceAmount'],
    };
}

export function InvestmentDetailsSourceOfMoneySplitViewModelToJSON(value?: InvestmentDetailsSourceOfMoneySplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AnnuitySourceAmount': value.annuitySourceAmount,
        'AlternativeSourceAmount': value.alternativeSourceAmount,
    };
}

